module.exports = __webpack_public_path__ + "media/packs/images/three-dots-focus-bf99719f3cef4a5d34b6e5ce89db3cc6.svg";